<template>
  <div style="width: 98%;margin-right: 1%;display: inline-block;">
    <el-card shadow="never" class="box-card" :body-style="{ padding: '0 12px 12px 12px'}">
      <div style="padding: 8px 8px 8px 0px;font-size: 14px;border-bottom: 1px solid #ebeef5;box-sizing: border-box;display: flex;justify-content: space-between;align-items: center">
        <div>
          实时消息
        </div>
        <el-button type="primary" plain size="small" @click="listenDisCount">Skinport扫货机器人</el-button>
      </div>
      <div style="height: 238px;overflow: auto" ref="messageContainter">
        <ul style="font-size: 12px">
          <li v-for="(msg, index) in messages" :key="index">{{ msg }}</li>
        </ul>
      </div>
    </el-card>

    <el-dialog size="mini" :visible.sync="listenDialog" width="480px">
      <el-tabs v-model="activeTab" @tab-click="handleClick" type="border-card">
        <el-tab-pane label="服务介绍" name="first">
          <h3 style="text-align: center;margin-top: 8px" class="plan-name">实时扫货机器人 & 更多平台求购排序</h3>
          <div style="display: flex;align-items: center">
            <ul style="list-style: none;gap:.75rem" class="plan">
              <li style="align-items: center;display: flex;">
                <svg style="color: #22c55e;margin-right: 12px" data-v-e8d572f6="" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"
                     aria-hidden="true" role="img" class="icon text-green-500 w-6 h-6" width="1em" height="1em"
                     viewBox="0 0 24 24">
                  <path fill="currentColor"
                        d="m10.6 13.8l-2.15-2.15q-.275-.275-.7-.275t-.7.275t-.275.7t.275.7L9.9 15.9q.3.3.7.3t.7-.3l5.65-5.65q.275-.275.275-.7t-.275-.7t-.7-.275t-.7.275zM12 22q-2.075 0-3.9-.788t-3.175-2.137T2.788 15.9T2 12t.788-3.9t2.137-3.175T8.1 2.788T12 2t3.9.788t3.175 2.137T21.213 8.1T22 12t-.788 3.9t-2.137 3.175t-3.175 2.138T12 22"></path>
                </svg>
                <span style="line-height: 1.75rem;font-weight: 100">
                  收费方式:  285 ￥ / 月
            </span>
              </li>
              <li style="align-items: center;display: flex;">
                <svg style="color: #22c55e;margin-right: 12px" data-v-e8d572f6="" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"
                     aria-hidden="true" role="img" class="icon text-green-500 w-6 h-6" width="1em" height="1em"
                     viewBox="0 0 24 24">
                  <path fill="currentColor"
                        d="m10.6 13.8l-2.15-2.15q-.275-.275-.7-.275t-.7.275t-.275.7t.275.7L9.9 15.9q.3.3.7.3t.7-.3l5.65-5.65q.275-.275.275-.7t-.275-.7t-.7-.275t-.7.275zM12 22q-2.075 0-3.9-.788t-3.175-2.137T2.788 15.9T2 12t.788-3.9t2.137-3.175T8.1 2.788T12 2t3.9.788t3.175 2.137T21.213 8.1T22 12t-.788 3.9t-2.137 3.175t-3.175 2.138T12 22"></path>
                </svg>
                <span style="line-height: 1.75rem;font-weight: 100">
                    7*24 实时邮件推送
                  </span>
              </li>
              <li style="align-items: center;display: flex;">
                <svg style="color: #22c55e;margin-right: 12px" data-v-e8d572f6="" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"
                     aria-hidden="true" role="img" class="icon text-green-500 w-6 h-6" width="1em" height="1em"
                     viewBox="0 0 24 24">
                  <path fill="currentColor"
                        d="m10.6 13.8l-2.15-2.15q-.275-.275-.7-.275t-.7.275t-.275.7t.275.7L9.9 15.9q.3.3.7.3t.7-.3l5.65-5.65q.275-.275.275-.7t-.275-.7t-.7-.275t-.7.275zM12 22q-2.075 0-3.9-.788t-3.175-2.137T2.788 15.9T2 12t.788-3.9t2.137-3.175T8.1 2.788T12 2t3.9.788t3.175 2.137T21.213 8.1T22 12t-.788 3.9t-2.137 3.175t-3.175 2.138T12 22"></path>
                </svg>
                <span style="line-height: 1.75rem;font-weight: 100">
                最快一单回本
              </span>
              </li>
              <li style="align-items: center;display: flex;">
                <svg style="color: #22c55e;margin-right: 12px" data-v-e8d572f6="" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"
                     aria-hidden="true" role="img" class="icon text-green-500 w-6 h-6" width="1em" height="1em"
                     viewBox="0 0 24 24">
                  <path fill="currentColor"
                        d="m10.6 13.8l-2.15-2.15q-.275-.275-.7-.275t-.7.275t-.275.7t.275.7L9.9 15.9q.3.3.7.3t.7-.3l5.65-5.65q.275-.275.275-.7t-.275-.7t-.7-.275t-.7.275zM12 22q-2.075 0-3.9-.788t-3.175-2.137T2.788 15.9T2 12t.788-3.9t2.137-3.175T8.1 2.788T12 2t3.9.788t3.175 2.137T21.213 8.1T22 12t-.788 3.9t-2.137 3.175t-3.175 2.138T12 22"></path>
                </svg>
                <span style="line-height: 1.75rem;font-weight: 100">
                可靠的比价信息与求购排序
              </span>
              </li>
            </ul>
            <img style="width: 168px;margin-left: 12px" src="../../../static/imgs/Skinport_bot.jpg"/>
          </div>
          <div style="text-align: center">
            <el-button style="min-width: 120px" type="primary" round disabled>  进群联系群主开通 </el-button>
          </div>
        </el-tab-pane>
<!--        <el-tab-pane label="推送规则" name="second">-->
<!--          <h3 style="text-align: center;margin-top: 8px" class="plan-name">-->
<!--            小于求购或告警价格-->
<!--          </h3>-->
<!--          <el-table-->
<!--            size="mini"-->
<!--            :data="alertItemData"-->
<!--            stripe-->
<!--            style="width: 100%">-->
<!--            <el-table-column-->
<!--              prop="cnName"-->
<!--              label="日期">-->
<!--            </el-table-column>-->
<!--            <el-table-column-->
<!--              prop="alertPrice"-->
<!--              label="告警价格"-->
<!--              width="110px"-->
<!--            >-->
<!--            </el-table-column>-->
<!--          </el-table>-->

<!--          <el-pagination-->
<!--            style="margin-top: 12px;float: right"-->
<!--            small-->
<!--            layout="prev, pager, next"-->
<!--            :total="searchForm.total"-->
<!--            @current-change="currentChange"-->
<!--          >-->
<!--          </el-pagination>-->
<!--        </el-tab-pane>-->
      </el-tabs>


    </el-dialog>
  </div>
</template>

<script>
import {queryWearStaff} from "../../api/api";

export default {
  name:'webSocket',
  data() {
    return {
      searchForm:{
        limit:10,
        offset:1,
        total:0
      },
      socket: null,
      messages: [],
      reconnectInterval: null,
      isReconnecting: false, // 新增一个标志位
      listenDialog: false,
      activeTab:'first',
      alertItemData:[]
    };
  },
  mounted() {
    this.connect();
  },
  beforeDestroy() {
    this.disconnect();
  },
  updated() {
    this.scrollToBottom();
  },
  methods: {
    currentChange(val){
      this.searchForm.offset = val
      this.handleClick()
    },
    handleClick(){
      queryWearStaff(this.searchForm).then(json=>{
        this.alertItemData = json.data.data.data
        this.searchForm.total = json.data.data.total
      })
    },
    listenDisCount(){
      this.listenDialog = true
    },
    scrollToBottom() {
      // 获取容器元素
      const messageContainter = this.$refs.messageContainter;
      // 将滚动条设置为滚动到最底部
      messageContainter.scrollTop = messageContainter.scrollHeight;
    },
    connect() {
      this.messages.push('WebSocket 建立连接中...')
      // ws://localhost:8081/hangKnife/websocket
      // ws://1.94.107.116:8081/hangKnife/websocket
      // wss://hangknife.com/hangKnife/websocket

      if (this.socket && this.socket.readyState === WebSocket.OPEN) {
        this.socket.close();
      }

      this.socket = new WebSocket('wss://hangknife.com/hangKnife/websocket');

      this.socket.onopen = () => {
        this.messages.push('WebSocket 连接已建立')
        this.isReconnecting = false; // 重置标志位
        clearInterval(this.reconnectInterval); // 连接成功时清除重连定时器
        this.reconnectInterval = null; // 确保重连任务被清除
      };

      this.socket.onmessage = (event) => {
        if (this.messages.length > 1000) { // 设置最大长度
          this.messages.shift(); // 移除最旧的消息
        }
        this.messages.push("["+new Date().toLocaleTimeString()+ "]  " + event.data);
      };

      this.socket.onclose = () => {
        this.messages.push('WebSocket 连接已关闭，准备进行重连')
      };

      this.socket.onerror = (error) => {
        this.messages.push('WebSocket 发生错误:', error)
      };
    },
    disconnect() {
      if (this.socket) {
        this.socket.close();
      }
      clearInterval(this.reconnectInterval); // 确保组件销毁时清除重连任务
    },
  },
};
</script>

<style>
/* 添加一些基本样式 */
h1 {
  font-size: 2em;
}
</style>



// WEBPACK FOOTER //
// src/ui/WebSocket/WebSocket.vue